/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetNoteDuplicatedCommand } from '../../models/set-note-duplicated-command';
import { SetNoteDuplicatedCommandResult } from '../../models/set-note-duplicated-command-result';

export interface ApiPlanSetNoteDuplicatedPost$Params {
  
    /**
     * Plan creation command
     */
    body?: SetNoteDuplicatedCommand
}

export function apiPlanSetNoteDuplicatedPost(http: HttpClient, rootUrl: string, params?: ApiPlanSetNoteDuplicatedPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SetNoteDuplicatedCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlanSetNoteDuplicatedPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SetNoteDuplicatedCommandResult>;
    })
  );
}

apiPlanSetNoteDuplicatedPost.PATH = '/api/Plan/SetNoteDuplicated';
